import { ViewModel } from '@descomplica/microfrontend-core';
import { action, computed, makeObservable } from 'mobx';

import { LESSON_TYPE } from '@/application/commons/enums/live.enum';
import { MixpanelContentLessonCardClick, Tracking } from '@/application/utils/tracking';
import { UserModel } from '@/presentation/models/user.model';
import { ClassifiersStore } from '@/presentation/stores/classifiers.store';
import { StudentClassesStore } from '@/presentation/stores/studentClasses.store';

@ViewModel()
export class LiveItemViewModel {
  constructor(
    private readonly userModel: UserModel,
    private studentClassesStore: StudentClassesStore,
    private classifiersStore: ClassifiersStore,
  ) {
    makeObservable(this);
  }

  handleContentLessonCardClick(liveStreaming) {
    const props: MixpanelContentLessonCardClick = {
      course: liveStreaming.course.slug,
      course_id: liveStreaming.course.guid,
      course_name: liveStreaming.course.name,
      lesson: liveStreaming.slug,
      lesson_id: liveStreaming.streaming.guid,
      lesson_name: liveStreaming.name,
      lesson_type: LESSON_TYPE.LIVE,
      teacher: liveStreaming?.teacher,
      student_id: liveStreaming.student_id,
      user: liveStreaming.user,
      email: liveStreaming.email,
      ...this.classifiersStore.classifiersTrackingInfo,
      ...this.studentClassesStore.getStudentClassesTrackingInfo(),
    };

    Tracking.contentLessonCardClick(props);
  }

  @action
  clearAccount() {
    return this.userModel.clearAccount();
  }

  @computed
  get user() {
    return this.userModel.user;
  }
}
